<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" size="small">
    <el-form-item>
      <el-input v-model="filters.userName" placeholder="学生姓名"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="searchFile"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      trainTypeData: [],
    };
  },
  methods: {
    resetData() {
      //重置
      this.filters = {};
      this.searchFile();
    },
    searchFile() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
